module.exports = __webpack_public_path__ + "img/Old-Video-Cam-icon.b0716408.png";